import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {EditPersonalDataComponent} from './edit-personal-data/edit-personal-data.component';
import {FinalClientElectricityComponent} from './electricity/final-client-electricity.component';
import {FinalClientGasComponent} from './gas/final-client-gas.component';
import {FinalClientNotificationsComponent} from './notifications/final-client-notifications.component';
import {AppAuthGuard} from '../../shared/guard/auth.guard';
import {
  ElectricityConsumptionPlaceDetailsComponent
} from './electricity/details/consumption-place/electricity-consumption-place-details.component';
import {GasConsumptionPlaceDetailsComponent} from './gas/details/consumption-place/gas-consumption-place-details.component';
import {ContractIndexComponent} from '../../public/contract-index/contract-index.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'date-identificare',
        component: EditPersonalDataComponent,
        data: {
          editable: true,
          title: 'Persoana fizica',
          breadcrumb: 'Date identificare'
        },
        canActivate: [AppAuthGuard],
      },
      {
        path: 'energie-electrica',
        component: FinalClientElectricityComponent,
        data: {
          title: 'Persoana fizica',
          breadcrumb: 'Energie electrica'
        }
      },
      {
        path: 'energie-electrica/loc-consum',
        component: ElectricityConsumptionPlaceDetailsComponent,
        data: {
          //title: "Persoana fizica",
          breadcrumb: 'Loc consum'
        }
      },
      {
        path: 'energie-electrica/index',
        component: ContractIndexComponent,
        data: {
          //title: "Persoana fizica",
          breadcrumb: 'Index'
        }
      },
      {
        path: 'gaze-naturale',
        component: FinalClientGasComponent,
        data: {
          title: 'Persoana fizica',
          breadcrumb: 'Gaze naturale'
        }
      },
      {
        path: 'gaze-naturale/loc-consum',
        component: GasConsumptionPlaceDetailsComponent,
        data: {
          //title: "Persoana fizica",
          breadcrumb: 'Loc consum'
        }
      },
      {
        path: 'gaze-naturale/index',
        component: ContractIndexComponent,
        data: {
          //title: "Persoana fizica",
          breadcrumb: 'Index'
        }
      },
      {
        path: 'notificari',
        component: FinalClientNotificationsComponent,
        data: {
          title: 'Persoana fizica',
          breadcrumb: 'Notificari'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule {
}
